<template>
  <div id="app">
    <!-- 顶部导航 -->
    <header_ style="display: none;" ref="exit_logins"/>
    <!-- 路由视图 -->
    <router-view></router-view>
  </div>
</template>

<script>
import header_ from './components/header_'
import login from './components/login'
export default {
  name: 'App',
  components: {
    header_,
    login,
  },
  //解决苹果浏览器ios10及以上Safari无法禁止缩放问题
  created (){
    // 阻止双击放大
    var lastTouchEnd = 0;
    document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    });
    document.addEventListener('touchend', function(event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, false);

    // 阻止双指放大
    document.addEventListener('gesturestart', function(event) {
        event.preventDefault();
    });
  }
}
</script>

<style>
*{
  margin:0;
  padding: 0;
}
html,body{
  width: 100%;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
a{
  text-decoration: none;
}

@media screen and (min-width: 800px) {
  body{
    height: 100%;
    overflow:hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue